{
    "$schema": "https://sdk.client-config.siriusxm.com/3.3.0-env.json",
    "config": {
        "domains": {
            "commerce": {
                "baseUrl": "",
                "endPoints": {
                    "activatePartnerEntitlement": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "partnerentitlements/v1/activate/{partnerEntitlementId}",
                        "method": "PUT",
                        "timeout": 15
                    },
                    "confirmOrder": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "order/v1/orders/{orderId}/confirm",
                        "method": "PUT",
                        "timeout": 15
                    },
                    "createBillingProfile": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles",
                        "method": "POST",
                        "timeout": 15
                    },
                    "createOrder": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "order/v1/orders",
                        "method": "POST",
                        "timeout": 15
                    },
                    "createPayment": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-methods/{paymentMethodId}/pay",
                        "method": "POST",
                        "timeout": 15
                    },
                    "createPaymentMethodsCardSetupToken": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-methods/card/setup-token",
                        "method": "POST",
                        "timeout": 15
                    },
                    "createPaymentMethodsFirstCardSetupToken": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/payment-methods/card/setup-token",
                        "method": "POST",
                        "timeout": 15
                    },
                    "createPaymentSetupToken": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/pay",
                        "method": "POST",
                        "timeout": 15
                    },
                    "deletePaymentMethod": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-methods/{paymentMethodId}",
                        "method": "DELETE",
                        "timeout": 15
                    },
                    "getBalanceDueDetails": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/balance-due",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getBillingProfile": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getBillingProfileNextBill": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/next-bill",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getBillingProfilePaymentHistory": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-history",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "startDateTime",
                                "required": true,
                                "value": "{startDateTime}"
                            },
                            {
                                "name": "endDateTime",
                                "required": true,
                                "value": "{endDateTime}"
                            },
                            {
                                "name": "paymentMethodId",
                                "required": false,
                                "value": "{paymentMethodId}"
                            },
                            {
                                "name": "pageSize",
                                "required": false,
                                "value": "{pageSize}"
                            },
                            {
                                "name": "nextToken",
                                "required": false,
                                "value": "{nextToken}"
                            },
                            {
                                "name": "orderBy",
                                "required": false,
                                "value": "{orderBy}"
                            },
                            {
                                "name": "entryType",
                                "required": false,
                                "value": "{entryType}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getDefaultBillingProfile": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profile/default",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getInvoice": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/invoices/{id}",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getInvoices": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/invoices",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "startDateTime",
                                "required": true,
                                "value": "{startDateTime}"
                            },
                            {
                                "name": "endDateTime",
                                "required": true,
                                "value": "{endDateTime}"
                            },
                            {
                                "name": "paymentMethodId",
                                "required": false,
                                "value": "{paymentMethodId}"
                            },
                            {
                                "name": "subscriptionId",
                                "required": false,
                                "value": "{subscriptionId}"
                            },
                            {
                                "name": "pageSize",
                                "required": false,
                                "value": "{pageSize}"
                            },
                            {
                                "name": "nextToken",
                                "required": false,
                                "value": "{nextToken}"
                            },
                            {
                                "name": "orderBy",
                                "required": false,
                                "value": "{orderBy}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getOrder": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "order/v1/orders/{orderId}",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getPartnerEntitlements": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "partnerentitlements/v1/entitlements",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getPaymentMethod": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-methods/{paymentMethodId}",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getPaymentMethodHistory": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-methods/{paymentMethodId}/history",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "startDateTime",
                                "required": false,
                                "value": "{startDateTime}"
                            },
                            {
                                "name": "endDateTime",
                                "required": false,
                                "value": "{endDateTime}"
                            },
                            {
                                "name": "pageSize",
                                "required": false,
                                "value": "{pageSize}"
                            },
                            {
                                "name": "nextToken",
                                "required": false,
                                "value": "{nextToken}"
                            },
                            {
                                "name": "orderBy",
                                "required": false,
                                "value": "{orderBy}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getPaymentMethods": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-methods",
                        "method": "GET",
                        "timeout": 15
                    },
                    "grantAccessPartner": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {deviceGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "activation/v1/grant-access/partner",
                        "method": "PUT",
                        "timeout": 15
                    },
                    "offerDetails": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "eligibility/v1/offers/catalog/{offerId}",
                        "method": "GET",
                        "timeout": 15
                    },
                    "offersChange": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "eligibility/v1/offers/change",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "country",
                                "required": false,
                                "value": "{country}"
                            },
                            {
                                "name": "promoCode",
                                "required": false,
                                "value": "{promoCode}"
                            },
                            {
                                "name": "baseTerm",
                                "required": false,
                                "value": "{baseTerm}"
                            },
                            {
                                "name": "trialPreference",
                                "required": false,
                                "value": "{trialPreference}"
                            },
                            {
                                "name": "subscription",
                                "required": true,
                                "value": "{subscription}"
                            },
                            {
                                "name": "billingPlatform",
                                "required": false,
                                "value": "{billingPlatform}"
                            }
                        ],
                        "timeout": 15
                    },
                    "offersNew": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "eligibility/v1/offers/new",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "country",
                                "required": false,
                                "value": "{country}"
                            },
                            {
                                "name": "promoCode",
                                "required": false,
                                "value": "{promoCode}"
                            },
                            {
                                "name": "baseTerm",
                                "required": false,
                                "value": "{baseTerm}"
                            },
                            {
                                "name": "trialPreference",
                                "required": false,
                                "value": "{trialPreference}"
                            },
                            {
                                "name": "billingPlatform",
                                "required": false,
                                "value": "{billingPlatform}"
                            }
                        ],
                        "timeout": 15
                    },
                    "offersSave": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "eligibility/v1/offers/save",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "country",
                                "required": false,
                                "value": "{country}"
                            },
                            {
                                "name": "promoCode",
                                "required": false,
                                "value": "{promoCode}"
                            },
                            {
                                "name": "baseTerm",
                                "required": false,
                                "value": "{baseTerm}"
                            },
                            {
                                "name": "trialPreference",
                                "required": false,
                                "value": "{trialPreference}"
                            },
                            {
                                "name": "subscription",
                                "required": true,
                                "value": "{subscription}"
                            },
                            {
                                "name": "billingPlatform",
                                "required": false,
                                "value": "{billingPlatform}"
                            }
                        ],
                        "timeout": 15
                    },
                    "redeemGiftCard": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/balance/redeem-giftcard",
                        "method": "POST",
                        "timeout": 15
                    },
                    "registerGiftCard": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "giftcard/v1/giftcards",
                        "method": "POST",
                        "queryParams": [
                            {
                                "name": "country",
                                "required": false,
                                "value": "{country}"
                            }
                        ],
                        "timeout": 15
                    },
                    "restore": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "activation/v1/restore/{restoreTarget}",
                        "method": "PUT",
                        "timeout": 15
                    },
                    "setBillingProfileDefaultPaymentMethod": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "queryParams": [
                            {
                                "name": "stripePaymentMethodId",
                                "required": false,
                                "value": "{stripePaymentMethodId}"
                            }
                        ],
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-methods/{paymentMethodId}/default",
                        "method": "POST",
                        "timeout": 15
                    },
                    "subscriptionForId": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "subscription/v1/subscriptions/{subscriptionId}",
                        "method": "GET",
                        "timeout": 15
                    },
                    "subscriptions": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "subscription/v1/subscriptions",
                        "method": "GET",
                        "timeout": 15
                    },
                    "sync": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "activation/v1/sync/{syncTarget}",
                        "method": "PUT",
                        "timeout": 15
                    },
                    "updateBillingProfile": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}",
                        "method": "PATCH",
                        "timeout": 15
                    },
                    "updatePaymentMethod": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "billing/v1/billing-profiles/{billingProfileId}/payment-methods/{paymentMethodId}",
                        "method": "PATCH",
                        "timeout": 15
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "config": {
                "baseUrl": "",
                "endPoints": {
                    "renderApplicationConfigWithSession": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "configservice/v1/applications/{id}/configs/{version}/me",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "enableProdMode",
                                "required": false,
                                "value": "{enableProdMode}"
                            }
                        ],
                        "timeout": 15,
                        "doesNotTriggerSessionRefresh": true
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "content": {
                "baseUrl": "",
                "endPoints": {
                    "browseContainerView": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "browse/v1/pages/{pageEntityType}/{pageEntityId}/containers/{containerId}/view",
                        "method": "POST",
                        "timeout": 15
                    },
                    "browsePageView": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "browse/v1/pages/{pageEntityType}/{pageEntityId}/view",
                        "method": "POST",
                        "timeout": 15
                    },
                    "bulkEdit": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/bulk-edit",
                        "method": "POST",
                        "timeout": 15
                    },
                    "channelPeek": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "channel-guide/v1/channel/{entityId}/peek",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getAllLibraryItems": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/all",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getAllNotificationItems": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/notification/all",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entityTypes",
                                "required": false,
                                "value": "{entityTypes}"
                            },
                            {
                                "name": "entityId",
                                "required": false,
                                "value": "{entityId}"
                            },
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getAutoDownloadFilterViews": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v2/autodownload/filter-views",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getAutoDownloadNewEpisodes": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v2/autodownload/new-podcast-episodes",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getAutoDownloadShowPodcasts": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v2/autodownload/show-podcast",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getContainer": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "{containerUrl}",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getContainerFromTastes": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getLibraryFilters": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/filters",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "deviceClass",
                                "required": false,
                                "value": "{deviceClass}"
                            },
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getLibraryFilterViews": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/filter-views",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getMadeForYouView": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/made-for-you-view",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getNewEpisodesView": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/new-episodes-view",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getNotificationFilters": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/notification/filters",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getNotificationFilterViews": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/notification/filter-views",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getPage": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "page/v1/page/{entityType}/{entityId}",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "enablePrimarySecondary",
                                "required": false,
                                "value": "{enablePrimarySecondary}"
                            },
                            {
                                "name": "enableEntityPagePickFeed",
                                "required": false,
                                "value": "{enableEntityPagePickFeed}"
                            },
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getPivotingContainer": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "recommender/v1/container/pivoting",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entityType",
                                "required": true,
                                "value": "{entityType}"
                            },
                            {
                                "name": "entityId",
                                "required": true,
                                "value": "{entityId}"
                            },
                            {
                                "name": "containerId",
                                "required": true,
                                "value": "{containerId}"
                            },
                            {
                                "name": "currentPage",
                                "required": true,
                                "value": "{currentPage}"
                            },
                            {
                                "name": "pageLimit",
                                "required": true,
                                "value": "{pageLimit}"
                            },
                            {
                                "name": "contentVersion",
                                "required": false,
                                "value": "{contentVersion}"
                            },
                            {
                                "name": "useCuratedContext",
                                "required": false,
                                "value": "{useCuratedContext}"
                            },
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getRelatedTaste": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "recommender/v1/get-related-taste",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entityType",
                                "required": false,
                                "value": "{entityType}"
                            },
                            {
                                "name": "entityId",
                                "required": false,
                                "value": "{entityId}"
                            },
                            {
                                "name": "currentPage",
                                "required": true,
                                "value": "{currentPage}"
                            },
                            {
                                "name": "pageLimit",
                                "required": true,
                                "value": "{pageLimit}"
                            },
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getSetSegment": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "{paginationUrl}",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "offset",
                                "required": true,
                                "value": "{offset}"
                            },
                            {
                                "name": "size",
                                "required": true,
                                "value": "{size}"
                            },
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getStationFeedback": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "stations/v1/station-feedback/station/type/{contentEntityType}/id/{contentEntityId}",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "itemEntityIds",
                                "required": true,
                                "value": "{itemEntityIds}"
                            },
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getTaste": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "recommender/v1/get-taste",
                        "method": "POST",
                        "queryParams": [
                            {
                                "name": "currentPage",
                                "required": true,
                                "value": "{currentPage}"
                            },
                            {
                                "name": "pageLimit",
                                "required": true,
                                "value": "{pageLimit}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getUserProgress": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/user-progress",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getYourEpisodesView": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/your-episodes-view",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "entitlementHash",
                                "required": false,
                                "value": "{entitlementHash}"
                            }
                        ],
                        "timeout": 15
                    },
                    "migrateDownloads": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/download/migration",
                        "method": "POST",
                        "timeout": 15
                    },
                    "removeAllContentActivities": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "content-activity-service/v1/content-activity",
                        "method": "DELETE",
                        "queryParams": [
                            {
                                "name": "activityType",
                                "required": true,
                                "value": "{activityType}"
                            }
                        ],
                        "timeout": 15
                    },
                    "setTaste": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "recommender/v1/set-taste",
                        "method": "POST",
                        "queryParams": [
                            {
                                "name": "currentPage",
                                "required": true,
                                "value": "{currentPage}"
                            },
                            {
                                "name": "pageLimit",
                                "required": true,
                                "value": "{pageLimit}"
                            }
                        ],
                        "timeout": 15
                    },
                    "subscribeAutoDownloadShowPodcast": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v2/autodownload/show-podcast/{entityId}",
                        "method": "PUT",
                        "timeout": 15
                    },
                    "unsubscribeAutoDownloadShowPodcast": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v2/autodownload/show-podcast/{entityId}",
                        "method": "DELETE",
                        "timeout": 15
                    },
                    "updateContentActivity": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "content-activity-service/v1/content-activity",
                        "method": "POST",
                        "timeout": 15
                    },
                    "updateLibrary": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/library/update",
                        "method": "POST",
                        "timeout": 15
                    },
                    "updateNotification": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ondemand/v1/notification/update",
                        "method": "POST",
                        "timeout": 15
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "image": {
                "baseUrl": "https://imgsrv-sxm-prod-device.streaming.siriusxm.com/{encodedImageParams}",
                "extras": {
                    "sizeMultiplier": 1.0,
                    "defaultResize": {
                        "width": 1080,
                        "height": 1080
                    },
                    "maxResize": {
                        "width": 1920,
                        "height": 1920
                    }
                }
            },
            "localization": {
                "baseUrl": "",
                "endPoints": {
                    "getLocalizations": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "localizationservice/v1/localizations",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "dictionaries",
                                "required": true,
                                "value": "{dictionaries}"
                            },
                            {
                                "name": "locale",
                                "required": false,
                                "value": "{locale}"
                            }
                        ],
                        "timeout": 15
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "outreach": {
                "baseUrl": "",
                "endPoints": {
                    "getMessage": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "ivm/v1/ivm/message",
                        "method": "GET",
                        "timeout": 15
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "partnerIntegration": {
                "baseUrl": "",
                "endPoints": {
                    "acceptTermsAndConditions": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "client-orchestration/v1/accept-terms",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getDetailedDeviceState": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "client-orchestration/v1/detailed-state/device",
                        "method": "GET",
                        "timeout": 15
                    },
                    "magicLinkRequest": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "client-orchestration/v1/request-magic-link",
                        "method": "POST",
                        "timeout": 15
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "playback": {
                "baseUrl": "",
                "endPoints": {
                    "getDecryptionKeyFromKeyId": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/key/v1/{keyId}",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getDecryptionKeyFromURL": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "{url}",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getLookaround": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "https://lookaround-cache-prod.streaming.siriusxm.com/playbackservices/v1/live/lookAround",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "delta",
                                "required": true,
                                "value": "{delta}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getLookaroundEpisodes": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "https://lookaround-cache-prod.streaming.siriusxm.com/playbackservices/v1/live/lookAroundEpisodes",
                        "method": "GET",
                        "timeout": 15
                    },
                    "liveUpdate": {
                        "codingOptions": {
                            "dateFormat": "yyyy-MM-dd'T'HH:mm:ss.SSSZ"
                        },
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/play/v1/liveUpdate",
                        "method": "POST",
                        "timeout": 15
                    },
                    "nextupAdd": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/nextup/v1/add",
                        "method": "POST",
                        "timeout": 15
                    },
                    "nextupEnable": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/nextup/v1/enable",
                        "method": "POST",
                        "timeout": 15
                    },
                    "nextupListQueuedItems": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/nextup/v1/listQueuedItems",
                        "method": "POST",
                        "timeout": 15
                    },
                    "nextupRemove": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/nextup/v1/remove",
                        "method": "POST",
                        "timeout": 15
                    },
                    "peek": {
                        "codingOptions": {
                            "dateFormat": "yyyy-MM-dd'T'HH:mm:ss.SSSZ"
                        },
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/play/v1/peek",
                        "method": "POST",
                        "timeout": 15
                    },
                    "previous": {
                        "codingOptions": {
                            "dateFormat": "yyyy-MM-dd'T'HH:mm:ss.SSSZ"
                        },
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/play/v1/previous",
                        "method": "POST",
                        "timeout": 15
                    },
                    "replay": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/play/v1/replay",
                        "method": "POST",
                        "timeout": 15
                    },
                    "skip": {
                        "codingOptions": {
                            "dateFormat": "yyyy-MM-dd'T'HH:mm:ss.SSSZ"
                        },
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/play/v1/skip",
                        "method": "POST",
                        "timeout": 15
                    },
                    "sportEvent": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "https://sports-cache-prod.streaming.siriusxm.com/playbackservices/v1/sports/event/{eventId}/summary",
                        "method": "GET",
                        "timeout": 15
                    },
                    "sportScores": {
                        "disableCaching": true,
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "https://sports-cache-prod.streaming.siriusxm.com/playbackservices/v1/sports/event/{eventId}/scores",
                        "method": "GET",
                        "timeout": 15
                    },
                    "streamsStatus": {
                        "disableCaching": true,
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/stream-enforcement/v1/status",
                        "method": "GET",
                        "timeout": 15
                    },
                    "telemetryBatchAction": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/telemetry/v2/actions",
                        "method": "POST",
                        "timeout": 15
                    },
                    "tuneSource": {
                        "codingOptions": {
                            "dateFormat": "yyyy-MM-dd'T'HH:mm:ss.SSSZ"
                        },
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "playback/play/v1/tuneSource",
                        "method": "POST",
                        "timeout": 15
                    }
                },
                "extras": {
                    "encryptedSources": [
                        "artist-station",
                        "channel-linear",
                        "channel-xtra",
                        "episode-audio",
                        "episode-podcast",
                        "episode-video"
                    ],
                    "keyRegex": "^https:[/][/].*?[/]key[/]v[0-9]+[/]([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})[/]?$",
                    "manifestVariant": null,
                    "telemetryBufferConfig": {
                        "flushOnBackground": true,
                        "flushOnEventCount": 10,
                        "flushOnLaunch": true,
                        "flushOnLogout": true,
                        "flushOnMinInterval": "PT10S",
                        "maxEventBatchCount": 20
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "search": {
                "baseUrl": "",
                "endPoints": {
                    "autosuggest": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "search/v1/autosuggest",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getRecentSearches": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "search/v1/recentSearches",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "resultSize",
                                "required": false,
                                "value": "{resultSize}"
                            },
                            {
                                "name": "entityType",
                                "required": false,
                                "value": "{entityTypes}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getSearchFilters": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "search/v1/getSearchFilters",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "deviceClass",
                                "required": false,
                                "value": "{deviceClass}"
                            }
                        ],
                        "timeout": 15
                    },
                    "getSearchResults": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "search/v1/search",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getTrendingSearches": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "search/v1/trendingSearches",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "resultSize",
                                "required": false,
                                "value": "{resultSize}"
                            },
                            {
                                "name": "entityType",
                                "required": false,
                                "value": "{entityTypes}"
                            }
                        ],
                        "timeout": 15
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "time": {
                "baseUrl": "",
                "endPoints": {
                    "getMetronome": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "time/v1/metronome",
                        "method": "GET",
                        "timeout": 15
                    }
                },
                "extras": {
                    "metronomeEnabled": true,
                    "initializationPollInterval": "PT5S",
                    "latencyBufferLength": 3,
                    "maxDiscrepancyInterval": "PT5S",
                    "postInitializationPollInterval": "PT30M",
                    "latencyBufferMinWeight": 0.2,
                    "latencyBufferMaxWeight": 1.0
                },
                "retry": {
                    "delaySeconds": 0,
                    "maxRetryCount": 0
                }
            },
            "user": {
                "baseUrl": "",
                "endPoints": {
                    "anonymous": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {deviceGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/sessions/anonymous",
                        "method": "POST",
                        "timeout": 15
                    },
                    "authenticated": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {identityGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/sessions/authenticated",
                        "method": "POST",
                        "timeout": 15
                    },
                    "authenticateMagicLink": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {magicLinkGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v2/identities/authenticate/magic-link",
                        "method": "POST",
                        "timeout": 15
                    },
                    "authenticatePassword": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v1/identities/authenticate/password",
                        "method": "POST",
                        "timeout": 15
                    },
                    "bypassTastePickingPreference": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "profile/v2/profiles/tastepicker",
                        "method": "PATCH",
                        "timeout": 15
                    },
                    "changePassword": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity-group/v1/identitygroups/change-password",
                        "method": "POST",
                        "timeout": 15
                    },
                    "changePhoneNumber": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity-group/v1/identitygroups/change-phone-number",
                        "method": "POST",
                        "timeout": 15
                    },
                    "checkSalStatus": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "uso-service/v3/sal",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "magicLinkGrant",
                                "required": true,
                                "value": "{magicLinkGrant}"
                            }
                        ],
                        "timeout": 15
                    },
                    "create": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "uso-service/v1/identities/create",
                        "method": "POST",
                        "timeout": 15
                    },
                    "createV2": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "uso-service/v2/identities/create",
                        "method": "POST",
                        "timeout": 15
                    },
                    "createAuthenticationChallenge": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "device/v1/device-authentication/challenge",
                        "method": "POST",
                        "timeout": 15
                    },
                    "createDeviceSession": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {vehicleProfileGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/sessions/device",
                        "method": "POST",
                        "timeout": 15
                    },
                    "delete": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "orchestration/v1/identities",
                        "method": "DELETE",
                        "timeout": 15
                    },
                    "devices": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8",
                            "X-SXM-Platform": "{platformName}",
                            "X-SXM-Tenant": "{tenantId}"
                        },
                        "href": "device/v1/devices",
                        "method": "POST",
                        "timeout": 15
                    },
                    "dmpCreateLWALinking": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/alexa/lwa/link",
                        "method": "POST",
                        "timeout": 15
                    },
                    "dmpGenerateLWAUrl": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/alexa/lwa/generate-url",
                        "method": "POST",
                        "timeout": 15
                    },
                    "dmpListConnectedDevices": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "dmp/v1/connected-devices",
                        "method": "GET",
                        "timeout": 15
                    },
                    "dmpListLinkedServices": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "dmp/v1/linked-services",
                        "method": "GET",
                        "timeout": 15
                    },
                    "dmpRenameDevice": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "dmp/v1/connected-device/rename/{deviceId}",
                        "method": "POST",
                        "timeout": 15
                    },
                    "dmpRevokeSessions": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "dmp/v1/sessions/revoke",
                        "method": "POST",
                        "timeout": 15
                    },
                    "getAccount": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "account/v2/accounts/me",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getIdentity": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v1/identities/me",
                        "method": "GET",
                        "timeout": 15
                    },
                    "getProfile": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "profile/v2/profiles/me",
                        "method": "GET",
                        "timeout": 15
                    },
                    "createAutoProfile": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {deviceGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "profile/v2/profiles/auto",
                        "method": "POST",
                        "timeout": 15
                    },
                    "issueCastingGrant": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/casting/grants/issue",
                        "method": "POST",
                        "timeout": 15
                    },
                    "linkCodeAuthorize": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/sonos/link-codes/authorize",
                        "method": "POST",
                        "timeout": 15
                    },
                    "magicLinkRedeem": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "magic-link/v1/redeem/{magicLinkId}",
                        "method": "POST",
                        "timeout": 15
                    },
                    "magicLinkRequest": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "client-orchestration/v1/request-magic-link",
                        "method": "POST",
                        "timeout": 15
                    },
                    "migrateDeviceGrant": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {deviceGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "device/v1/grant/migration",
                        "method": "POST",
                        "timeout": 15
                    },
                    "migrateSession": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/sessions/migrate",
                        "method": "POST",
                        "timeout": 15
                    },
                    "oauthThirdParty": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/oauth/auth-code",
                        "method": "POST",
                        "timeout": 15
                    },
                    "otpAuthenticate": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {otpGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v1/identities/authenticate/otp",
                        "method": "POST",
                        "timeout": 15
                    },
                    "otpInitiate": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "otp/v1/otp/initiate",
                        "method": "POST",
                        "timeout": 15
                    },
                    "otpInitiateVerification": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "otp/v1/otp/initiate/verification",
                        "method": "POST",
                        "timeout": 15
                    },
                    "otpRedeem": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "otp/v1/otp/redeem",
                        "method": "PUT",
                        "timeout": 15
                    },
                    "override": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "uso-service/v1/override",
                        "method": "POST",
                        "timeout": 15
                    },
                    "passkeyAuthenticateFinish": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {startGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v1/identities/authenticate/webauthn/finish",
                        "method": "POST",
                        "timeout": 15
                    },
                    "passkeyAuthenticateStart": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v1/identities/authenticate/webauthn/start",
                        "method": "POST",
                        "timeout": 15
                    },
                    "passkeyCreateFinish": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {startGrant}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v1/identities/create/webauthn/finish",
                        "method": "POST",
                        "timeout": 15
                    },
                    "passkeyCreateStart": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v1/identities/create/webauthn/start",
                        "method": "POST",
                        "timeout": 15
                    },
                    "recordOfSaleExists": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "record-of-sale/v1/exists",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "email",
                                "required": true,
                                "value": "{emailAddress}"
                            }
                        ],
                        "timeout": 15
                    },
                    "recordOfSaleStatus": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "record-of-sale/v1/records/{smsSubscriptionId}/status",
                        "method": "GET",
                        "timeout": 15
                    },
                    "recordPrivacyOptionByIdentityId": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "privacy-options/v1/record/opt-out",
                        "method": "PUT",
                        "timeout": 15
                    },
                    "refresh": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {refreshToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/sessions/refresh",
                        "method": "POST",
                        "timeout": 15,
                        "doesNotTriggerSessionRefresh": true
                    },
                    "refreshDeviceGrant": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "device/v1/grant/refresh",
                        "method": "POST",
                        "timeout": 15,
                        "doesNotTriggerSessionRefresh": true
                    },
                    "register": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8",
                            "X-SXM-Tenant": "{tenantId}"
                        },
                        "href": "client-orchestration/v1/register",
                        "method": "POST",
                        "timeout": 15
                    },
                    "revokeSessions": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}"
                        },
                        "href": "session/v1/sessions/revoke/all",
                        "method": "POST",
                        "timeout": 15
                    },
                    "status": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "identity/v1/identities/status",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "handle",
                                "required": true,
                                "value": "{handle}"
                            }
                        ],
                        "timeout": 15
                    },
                    "statusForSignUp": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "uso-service/v1/identities/status",
                        "method": "GET",
                        "queryParams": [
                            {
                                "name": "handle",
                                "required": true,
                                "value": "{handle}"
                            }
                        ],
                        "timeout": 15
                    },
                    "updateAccount": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "account/v2/accounts",
                        "method": "PATCH",
                        "timeout": 15
                    },
                    "updateUserProfile": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "profile/v2/profiles",
                        "method": "PATCH",
                        "timeout": 15
                    },
                    "userCodeAuthenticate": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/device-authorization/sessions/create",
                        "method": "POST",
                        "timeout": 15
                    },
                    "userCodeAuthorize": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "session/v1/device-authorization/user-codes/authorize",
                        "method": "POST",
                        "timeout": 15
                    },
                    "userCodeGenerate": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "queryParams": [
                            {
                                "name": "flow",
                                "required": false,
                                "value": "{flow}"
                            }
                        ],
                        "href": "session/v1/device-authorization/user-codes/generate",
                        "method": "POST",
                        "timeout": 15
                    },
                    "verifyAuthenticationChallenge": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "device/v1/device-authentication/grant",
                        "method": "POST",
                        "timeout": 15
                    }
                },
                "extras": {
                    "featureFlag": true,
                    "isPasskeyEnabled": true
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "userEvents": {
                "baseUrl": "",
                "endPoints": {
                    "submit": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "user-event/v1/events/submit",
                        "method": "POST",
                        "timeout": 15
                    }
                },
                "extras": {
                    "userEventsBufferConfig": {
                        "flushOnBackground": true,
                        "flushOnEventCount": 300,
                        "flushOnLaunch": true,
                        "flushOnLogout": true,
                        "flushOnMinInterval": "PT30M",
                        "maxEventBatchCount": 1024
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            },
            "voice": {
                "baseUrl": "",
                "endPoints": {
                    "voiceAsText": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "voice/v1/voiceAsText",
                        "method": "POST",
                        "timeout": 15
                    },
                    "voiceAsTextV2": {
                        "headers": {
                            "Accept": "application/json; charset=utf-8",
                            "Authorization": "Bearer {accessToken}",
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        "href": "voice/v2/voiceAsText",
                        "method": "POST",
                        "timeout": 15
                    }
                },
                "retry": {
                    "delaySeconds": 2,
                    "maxRetryCount": 3
                }
            }
        },
        "extras": {}
    }
}
